import {LocalStorageService} from 'ngx-webstorage';
import { Input, Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-quote-step2',
  templateUrl: './quote-step2.component.html',
  styleUrls: ['./quote-step2.component.css']
})
export class QuoteStep2Component implements OnInit {
  username: String |""
  @Input() error: string | null;
  random
  form: FormGroup = new FormGroup({
    question1: new FormControl(''),
    question2: new FormControl(''),
  });

  constructor(private storage:LocalStorageService, private router: Router) { }
  ngOnInit() {
    this.username = this.storage.retrieve('username');
    let max = 99999
    let min = 10000
    this.random = Math.floor(Math.random() * (max - min + 1)) + min;
    this.storage.store('quoteId',this.random.toString())
  }
  submit(){
    console.log('submit')
    this.router.navigateByUrl('confirmation')
  }

  back(){
    console.log('back')
    this.router.navigateByUrl('home')
  }

  q2ChangeEvent(event){
    if (this.form.controls.question2.value == "q2choice1"){
      this.error = null;
    } else{
      this.error = 'simulated an error'
    }
  }
}
